module.exports = __webpack_public_path__ + "static/flags/KP-4b8de0be4914874d3024650142f4cecf.gif";